window.bindCancelButtons = function() {
  $('.inline-cancel').click(function() {
    toggle_inline($(this));
    reset_form($(this).data('form'));
    return false;
  });

  $('.cancel-iframe').click(function() {
    if (window.parent && window.parent.$.fancybox) {
      window.parent.$.fancybox.close();
    }
    return false;
  });

  $('.cancel').click(function() {
    if ($(this).data('item-id')) {
      $($(this).data('item-id')).hide();
    }
    $.fancybox.close();
    if ($(this).form) {
      $(this).form.reset();
    }
    return false;
  });
};

window.bindActionButtons = function() {
  $(document).on('click', '.form-toggle', function(jqEvent) {
    jqEvent.preventDefault();
    $($(this).data('toggle')).toggle();
    return false;
  });

  $(document).on('click', '.section-toggle', function(jqEvent) {
    jqEvent.preventDefault();
    const text = $(this).text();
    const toggle_id = $(this).data('toggle');

    if (text === 'Show') {
      $(this).text('Hide');
      $(toggle_id).slideDown();
    } else {
      $(this).text('Show');
      $(toggle_id).slideUp();
    }

    return false;
  });

  $('.inline-form-toggle').click(function() {
    toggle_inline($(this));
    return false;
  });

  $('.showhide').click(function() {
    const obj = $(this).children();
    const toggle_id = obj.data('toggle');

    if (obj.text() === 'Show') {
      obj.html('Hide<i class="icon-chevron-up"></i>');
      $(toggle_id).slideDown();
    } else {
      obj.html('Show<i class="icon-chevron-down"></i>');
      $(toggle_id).slideUp();
    }

    return false;
  });
};

$(function() {
  $('.date-field').datepicker({
    minDate: 0,
    dateFormat: 'yy-mm-dd'
  });

  $('#lead_event_date').datepicker({
    minDate: 0,
    dateFormat: 'yy-mm-dd'
  });

  $('.date-time-field').datetimepicker({
    ampm: true,
    stepMinute: 15
  });

  $('.search-date-field').datepicker({
    dateFormat: 'yy-mm-dd'
  });

  bindCancelButtons();
  bindActionButtons();

  $('.fancy-form').fancybox({
    autoSize: true,
    closeClick: false
  });

  $('.fancy-form-message').fancybox({
    autoSize: true,
    closeClick: false,
    type: 'iframe',
    width: 400,
    height: 300
  });

  $('.fancy-form-vendor-contact').fancybox({
    autoSize: true,
    closeClick: false,
    type: 'iframe',
    width: 400,
    height: 440
  });

  $('#messages_area > form').submit(function() {
    $(this).children('.asset-display-area').empty();
    return true;
  });

  $('#messages_area > form > a').click(function() {
    $(this).parent().find('.asset-display-area').empty();
    return true;
  });
});

$(function() {
  $('.modal-form-primary').fancybox({
    autoSize: true,
    closeClick: false,
    type: 'iframe',
    width: 460,
    height: 600
  });
});